import React from 'react';
import './GameListPage.css';
import { Grid, Row, Col } from 'react-bootstrap';
import GameLink from '../GameLink/index';
import PropTypes from 'prop-types';
import withSounds from '../../withSounds';

const GameLinkWithSounds = withSounds({ mouseEnterSound: true })(GameLink);

function GameListPage({ games, onInteraction }) {
  return (
    <div className="game-list-page">
      <Grid fluid>
        <Row>
          {games.map(function(object, i) {
            return (
              <Col
                xs={3}
                key={object.name}
                className="game-list-item"
                onMouseEnter={onInteraction}
              >
                <GameLinkWithSounds key={i} game={object} />
              </Col>
            );
          })}
        </Row>
      </Grid>
    </div>
  );
}

GameListPage.propTypes = {
  games: PropTypes.array,
  onInteraction: PropTypes.func
};

export default GameListPage;



// WEBPACK FOOTER //
// ./src/containers/GameList/GameListPage/index.js